import { render, staticRenderFns } from "./PartBaseInfoSetting.vue?vue&type=template&id=03db778e&scoped=true&"
import script from "./PartBaseInfoSetting.vue?vue&type=script&lang=js&"
export * from "./PartBaseInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./PartBaseInfoSetting.vue?vue&type=style&index=0&id=03db778e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db778e",
  null
  
)

export default component.exports